//유저 로그인?

import axios from "axios";
import { URL } from "../constants";
const noAuthClient = axios.create({
  baseURL: URL,
  timeout: 10000,
});

noAuthClient.defaults.withCredentials = false;

const loginHooks = async ({ userId, password }) => {
  try {
    const res = await noAuthClient.post("/api/v1/admin/login", {
      id: userId,
      password: password,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const issuedTokenHooks = async ({ token }) => {
  try {
    const res = await noAuthClient.get("/api/v1/admin/issued", {
      headers: {
        Authorization: token,
      },
    });
    if (res.data.error) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const userHooks = { loginHooks, issuedTokenHooks };

export default userHooks;
